// extracted by mini-css-extract-plugin
export var closeButton = "_15-1";
export var container = "_15-0";
export var fullModalImage = "_15-2";